import axios from 'axios';
import resolve  from './../resolver.js';
import checkJwt from './../../Global/jwtChecker' 
import logout from './../../Global/logout' 

export default async function GetClientInfo() {
    const unHashedJwt = await checkJwt()

    if(!unHashedJwt){
        logout()
    }

    return await resolve(
        axios( 'client/info', {
            method: 'get',
            headers: { 'Authorization' : unHashedJwt.data}           
        }).then(res => res.data)
        .catch(error => error.response.data)
        );
}